import mapValues from 'just-map-values';
import qs from 'qs';

export function generateManufacturerId({ brand, model, serial }: { brand: string; model: string; serial: string }): string {
  const url = new URL('https://dummy.com');
  if (brand) url.searchParams.append('b', brand.toUpperCase());
  if (model) url.searchParams.append('m', model.toUpperCase());
  if (serial) url.searchParams.append('s', serial.toUpperCase());
  const [_dummy, result] = url.toString().split('?');
  return result || '';
}

export function uppercaseManufacturerId(manufacturerId: string): string {
  return qs.stringify(mapValues(qs.parse(manufacturerId), (s) => (typeof s === 'string' ? s.toUpperCase() : s)));
}
